/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import {
  isPushNotificationSupported,
  sendNotification,
  initializePushNotifications,
  registerServiceWorker,
} from '../utils/Notifications/pushNotifications';

import adImageExample from '../assets/images/static/notification_demo1.jpg';
import adImageExample2 from '../assets/images/static/notification_demo2.jpg';
import DisneyIcon from '../assets/images/icons/disney-blue.svg';
import PlaneIcon from '../assets/images/icons/plane-blue.svg';
import BoatIcon from '../assets/images/icons/boat-blue.svg';

const NotificationsContext = React.createContext({});

export function NotificationsProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [isPanelOpened, setIsPanelOpened] = useState(false);
  const pushNotificationSuported = isPushNotificationSupported();

  const initialState = [
    {
      id: '1',
      type: 'info',
      status: 'cancelled',
      body: {
        image: PlaneIcon,
        type: 'flight',
        name: {
          first: 'Nombre,',
          last: 'Apellido',
        },
        detail: {
          name: 'American Airlines -',
          number: '123',
          days: '',
          message: '',
          price: '',
          currency: '',
        },
      },
      read: false,
    },
    {
      id: '2',
      type: 'ad',
      status: '',
      body: {
        image: adImageExample,
        type: '',
        name: {
          first: 'Tower Sale',
          last: '',
        },
        detail: {
          name: 'Republica Dominicana',
          number: '',
          days: '7',
          message: 'noches todo incluido -',
          price: '856',
          currency: 'USD',
        },
      },
      read: false,
    },
    {
      id: '3',
      type: 'info',
      status: 'approved',
      body: {
        image: BoatIcon,
        type: 'cruice',
        name: {
          first: 'Nombre,',
          last: 'Apellido',
        },
        detail: {
          name: 'Costa Crucero -',
          number: '5566',
          days: '',
          message: '',
          price: '',
          currency: '',
        },
      },
      read: false,
    },
    {
      id: '4',
      type: 'info',
      status: 'pending',
      body: {
        image: DisneyIcon,
        type: 'disney',
        name: {
          first: 'Nombre,',
          last: 'Apellido',
        },
        detail: {
          name: 'Parque EPCOT',
          number: '',
          days: '',
          message: '',
          price: '',
          currency: '',
        },
      },
      read: false,
    },
    {
      id: '5',
      type: 'ad',
      status: '',
      body: {
        image: adImageExample2,
        type: '',
        name: {
          first: 'Tower Sale',
          last: '',
        },
        detail: {
          name: 'Rio de Janeiro',
          number: '',
          days: '7',
          message: 'noches todo incluido -',
          price: '330',
          currency: 'USD',
        },
      },
      read: false,
    },
  ];

  useEffect(() => {
    // audio.play();
    if (pushNotificationSuported) {
      // registerServiceWorker();
      initializePushNotifications().then((consent) => {
        if (consent === 'granted') {
          sendNotification();
        }
      });
    }

    setNotifications(initialState);
  }, []);

  useEffect(() => {
    // console.log('NotificationsProvider', isPanelOpened);
  }, [isPanelOpened]);

  return (
    <NotificationsContext.Provider
      value={{ notifications, isPanelOpened, setIsPanelOpened }}
    >
      {children}
    </NotificationsContext.Provider>
  );
}

export default NotificationsContext;
